export default __webpack_public_path__ + "static/media/trackskills.8f988ab1.png";